import VehiculeFormController from './vehicule.form.controller';

export default {
    template: require('./vehicule.form.html'),
    controller: VehiculeFormController
};
